import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { setInfluenceAnalysisMinMaxMetric as setInfluenceAnalysisMinMaxMetricDiagram, getInfluenceAnalysisMinMaxMetric as getInfluenceAnalysisMinMaxMetricDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type MinMaxProps = ApiMethodBase & {
    min: number;
    max: number;
};

export const setInfluenceAnalysisMinMaxMetric = ({
    min,
    max,
}: MinMaxProps) => {
    setInfluenceAnalysisMinMaxMetricDiagram({min, max});
    apiProvider.updateDiagramInfluencers();
};


export const getInfluenceAnalysisMinMaxMetric = (): MinMaxProps => getInfluenceAnalysisMinMaxMetricDiagram();
